import Whatsapp from 'styles/images/svg/whatsapp.svg';
import sharedStyles from 'styles/css/SharedStyles.module.scss';

const SupportIcons = () => {


    return (
        <div id={'segment-support-icons'} className={sharedStyles['container-wraper']}>
        	<div className={sharedStyles['support-segment']}>
            	<a href="https://wa.me/+989174266582">
            		<img src={Whatsapp} width={60} className={sharedStyles['cursor-pointer']} alt="تماس در واتس اپ" />
            	</a>
            </div>
        </div>
    );
}

export default SupportIcons;
